import React from 'react'
import {Link} from 'react-router-dom'
import {avatarFor} from './components/ProfilePicture'

export default function SlimmerLink({slimmer={}, show='avatar', children}) {
  const label = show === 'avatar' ? avatarFor(slimmer) : slimmer.name
  return <Link to={slimmer.url || ''}>{children || label}</Link>
}
